import { Box, Grid, Tab, Tabs, styled } from "@mui/material";

export function DrawerTabs({ value, onChange, destinations }) {
  return (
    <Grid item xs={12}>
      <BoxTab>
        <Tabs
          value={value}
          onChange={onChange}
          aria-label="secondary tabs example"
        >
          {destinations?.map((data) => (
            <Tab value={data.id} label={data.name} />
          ))}
        </Tabs>
      </BoxTab>
    </Grid>
  );
}

const BoxTab = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(3),
  ".MuiTabs-root": {
    width: "100%",
    div: {
      display: "flex",
      justifyContent: "space-around",
      width: "100%",
    },
  },
}));

export default DrawerTabs;
